import React from 'react'

const CODE_SITUATION_PERFORMED = '8'
const CODE_SITUATION_CLOSED = '9'

const TaskCellSituation = (props) => {
  const oneData = props.oneData
  const colourForData = oneData.dfr
    ? 'red'
    : oneData.addwrk
      ? 'orange'
      : [CODE_SITUATION_PERFORMED, CODE_SITUATION_CLOSED].includes(oneData.codeSituation)
        ? 'green'
        : oneData.manhr || oneData.addwork
          ? 'blue'
          : ''

  return <div style={{ color: colourForData !== '' ? colourForData : 'inherit' }}>{oneData.situation}</div>
}

export default TaskCellSituation
